export class ClassSettingsAdapterSize {
  constructor(config) {
    this.config = config
  }

  fontSize(v) {
    switch (v) {
      case 0: return 10
      case 1: return 14
      case 2: return 19
      default: return 14
    }
  }

  iconStopSize(v) {
    switch (v) {
      case 0: return 8
      case 1: return 11
      case 2: return 16
      default: return 11
    }
  }

  iconCarSize(v) {
    switch (v) {
      case 0: return { w: 15, h: 18 }
      case 1: return { w: 21, h: 25 }
      case 2: return { w: 29, h: 35 }
      default: return { w: 21, h: 25 }
    }
  }

  lineSize(v) {
    switch (v) {
      case 0: return 4
      case 1: return 6
      case 2: return 8
      default: return 6
    }
  }
}

export const adapterModelSettingsUI = ({ font_size, element_size, line_size }) => {
  const utils = new ClassSettingsAdapterSize()
  let result = {
    font_size: utils.fontSize(font_size),
    icon_stop_size: utils.iconStopSize(element_size),
    icon_car_size: utils.iconCarSize(element_size),
    line_size: utils.lineSize(line_size)
  }
  return result
}